export const parseNarrativeAssessmentLine = (markdown = "") => {
  const raw = String(markdown || "").trim();
  const compact = raw.replace(/\s+/g, " ").trim();
  if (!compact) return null;

  const match = compact.match(/^(.+?Assessment)\s*:\s*([\s\S]+)$/i);
  if (!match) return null;

  return {
    title: String(match[1] || "").trim(),
    body: String(match[2] || "").trim(),
  };
};

export const isNarrativeAssessmentLine = (markdown = "") =>
  Boolean(parseNarrativeAssessmentLine(markdown));

export const normalizeNarrativeAssessmentTitle = (title = "") =>
  String(title || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const splitNarrativeSentences = (text = "") => {
  const raw = String(text || "").trim();
  if (!raw) return [];
  // Only split when punctuation is followed by whitespace/end, so decimals
  // and dotted tokens don't create fake bullets.
  const matches = raw.match(/.+?(?:[.!?]+(?=\s|$)|$)/g);
  return (matches || []).map((s) => s.trim()).filter(Boolean);
};
